import { paths } from "src/paths";

/**
 * 메뉴 없는 지도 새창인지 판정한다.
 * @param {string} search URL 검색문자열
 * @returns {boolean} 사용자 config 대신 임시 config를 사용할지 여부
 */
export const isTransientMapConfig = (search) =>
  new URLSearchParams(search).get("menu") === "false";

/**
 * 아파트 ID와 선택 평형 ID로 메뉴 없는 지도검색 새창 URL을 만든다.
 * @param {string|number} aptId 아파트 ID
 * @param {string|number} pyeongId 선택 공급평형 ID
 * @returns {string} 지도검색 URL
 */
export const buildAptMapSearchUrl = (aptId, pyeongId) => {
  const params = new URLSearchParams({ aptId: String(aptId) });
  if (pyeongId) params.set("pyeongId", String(pyeongId));
  params.set("menu", "false");
  return `${paths.dashboard.apts.selectmap}?${params.toString()}`;
};

/**
 * 조회한 아파트를 지도 중심으로 이동시키고 전달된 공급평형을 선택하는 설정을 만든다.
 * @param {object} apt 아파트 정보
 * @param {string|number} pyeongId 선택 공급평형 ID
 * @returns {object|null} 지도 설정 변경값
 */
export const buildAptMapTargetConfig = (apt, pyeongId) => {
  const latitude = Number(apt?.latitude);
  const longitude = Number(apt?.longitude);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

  const targetConfig = {
    latitude,
    longitude,
    zoom: 16,
  };

  // 평형 화면에서 진입했을 때만 해당 공급평형을 지도 선택 상태로 연다.
  if (pyeongId) targetConfig.selectedPyeongs = [String(pyeongId)];
  return targetConfig;
};

/**
 * 검색한 공급평형을 선택하면서 지도 데이터는 현재 bounds 조회를 계속 사용하게 한다.
 * @param {object} apt 검색에서 선택한 공급평형 정보
 * @returns {{config: object, fixedApts: null}|null} 지도 설정과 데이터 소스 설정
 */
export const buildAptSearchSelection = (apt) => {
  if (!apt?.pyeongId) return null;

  const config = buildAptMapTargetConfig(apt, apt.pyeongId);
  if (!config) return null;

  return {
    config,
    // 검색 결과 한 건으로 고정하지 않고 이동한 지도의 bounds에서 주변 아파트를 조회한다.
    fixedApts: null,
  };
};
